import { get, isFunction } from "lodash-es";
import { tryEval } from '@tencent/ui-core/lib/utils';
import { getRequestMsg, getResponseMsg } from "./frontEndHttpLog";
import { getHostByUrl } from "../../../tools/url";
import { pluginStateMap } from "../../../components/CollectionDetailModals/CgisEditPanel/stepsConfig/frontEndHook/pluginState";
import { message } from 'ant-design-vue';
import cgiFEPluginRuntimeService from "../../cgiFEPluginRuntimeService";
const pluginMapByProjectId = new Map();
function getPlugins(projectId) {
  if (!pluginMapByProjectId.has(projectId)) {
    const p = new Promise(resolve => {
      cgiFEPluginRuntimeService.list(projectId).then(list => {
        const map = list.reduce((prev, item) => {
          prev[item.pluginId] = item;
          return prev;
        }, {});
        resolve(map);
      });
    }).catch(e => {
      message.error('获取前端数据源插件列表失败');
      throw e;
    });
    pluginMapByProjectId.set(projectId, p);
  }
  return pluginMapByProjectId.get(projectId);
}
export const frontEndHttpHookMiddleware = async (ctx, next) => {
  if (ctx.collection.type !== 'frontEndHttp') {
    await next();
    return;
  }
  const cgiInfo = get(ctx, 'cgiInfo');
  let {
    beforeHooks = [],
    afterHooks = []
  } = cgiInfo;
  [beforeHooks, afterHooks] = [beforeHooks, afterHooks].map(item => item.filter(item => item.enabled));
  if (beforeHooks.length + afterHooks.length <= 0) {
    await next();
    return;
  }
  const {
    isDebug,
    requestConfig,
    projectId
  } = ctx;
  const beforeContext = {
    options: ctx.request,
    requestConfig
  };
  for (const before of beforeHooks) {
    const script = await getHookScript(before, projectId, isDebug);
    const func = beforeProxy.getFunc(script);
    if (isFunction(func)) {
      var _ctx$loggerForFrontEn;
      await func(beforeContext);
      (_ctx$loggerForFrontEn = ctx.loggerForFrontEndHttp) === null || _ctx$loggerForFrontEn === void 0 || _ctx$loggerForFrontEn.append({
        dimen4: 'beforeHook',
        dimen5: 'config',
        host: getHostByUrl(requestConfig.url),
        url: requestConfig.url,
        level: 1,
        msg: getRequestMsg(requestConfig)
      });
    }
  }
  // 用户自定义请求方法
  const customRequest = get(beforeContext, 'customRequest');
  if (typeof customRequest === 'function') {
    ctx.customRequest = customRequest;
  }
  await next();
  const afterContext = {
    response: ctx.response
  };
  for (const after of afterHooks) {
    const script = await getHookScript(after, projectId, isDebug);
    const func = afterProxy.getFunc(script);
    if (isFunction(func)) {
      var _ctx$loggerForFrontEn2;
      await func(afterContext);
      (_ctx$loggerForFrontEn2 = ctx.loggerForFrontEndHttp) === null || _ctx$loggerForFrontEn2 === void 0 || _ctx$loggerForFrontEn2.append({
        dimen4: 'afterHook',
        dimen5: 'result',
        host: getHostByUrl(requestConfig.url),
        url: requestConfig.url,
        level: 1,
        msg: getResponseMsg(ctx.response)
      });
    }
  }
};
class FuncProxy {
  constructor() {
    this.map = new Map(); // 数据不多，后面再接lru
  }
  getFunc(script) {
    if (!script) {
      return null;
    }
    if (!this.map.has(script)) {
      const func = this.getFuncByScript(script);
      this.map.set(script, func);
    }
    return this.map.get(script);
  }
  clear() {
    this.map.clear();
  }
  getFuncByScript(script) {
    const func = tryEval(script);
    return func;
  }
}
const beforeProxy = new FuncProxy();
const afterProxy = new FuncProxy();
async function getHookScript(hook, projectId, isDebug) {
  if (!hook.isPlugin) {
    return hook.script;
  }
  if (isDebug) {
    const pluginState = pluginStateMap.get(hook);
    if (!pluginState) {
      throw errorOnNotFound(hook);
    }
    return pluginState.plugin.code;
  }
  const map = await getPlugins(projectId);
  const plugin = map[hook.pluginId];
  if (!plugin) {
    throw errorOnNotFound(hook);
  }
  return plugin.code;
}
function errorOnNotFound(hook) {
  const msg = `插件「${hook.pluginId}」未找到，请刷新重试`;
  message.error(msg);
  return Error(msg);
}
//# sourceMappingURL=frontEndHttpHook.js.map
